(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const discounts = {
    GSEARLYBIRD: 300.00,
    EARLYBIRD: 300.00,
    AIMEE: 300.00,
    LAUREN200: 200.00,
    LFCREW: 350.00,
    GROWNSTRONG: 200.00,
    SOMERS300: 300.00,
    CLUB1PC: 1234.00,
    ROBYN: 200.00,
    FOREVERFREE: 300.00,
    CF300: 300.00,
    CFVIP500: 500.00,
    BALI500: 500.00,
    BAYLEE300: 300.00,
    DANCER: 250.00,
    CALLEDTOB: 250.00,
    LETSGO: 750.00,
    RETREAT300: 300.00,
    GSOGFAM: 1000.00,
    SERVICE300: 300.00,
    CAPETOWN300: 300.00,
    DELLE: 250.00,
    VALENTINE2026: 500.00,
    GSWELCOME: 200.00,
    Brooke: 200.00,
    COSTARICA200: 200.00,
    COSTARICA: 200.00,
    PAYTHEMAN: 200.00,
    ADVENTURE200: 200.00,
    STRONG300: 300.00,
    RETREAT400: 400.00,
    CROATIA200: 200.00,
    LAUREN300: 300.00,
    CAPETOWN200: 200.00,
    LASTCHANCE: 250.00,
    Xd8gsk3: 500.00,
    CAPETOWN500: 500.00,
  };

  const init = () => {
    const drawer = document.getElementById('drawer-cart');
    if (!drawer || drawer.dataset.retreatDiscountBound === 'true') return;
    drawer.dataset.retreatDiscountBound = 'true';

    const discountAmounts = new Map(
      Object.entries(discounts).map(([code, amount]) => [
        code.trim().toUpperCase(), Math.round(amount * 100)
      ])
    );
    const normalize = (code) => String(code || '').trim().toUpperCase();
    const baseCurrency = drawer.dataset.retreatBaseCurrency;
    const locale = drawer.dataset.retreatLocale || document.documentElement.lang || 'en';
    const showCurrency = drawer.dataset.retreatShowCurrency === 'true';
    let activeCode = normalize(drawer.dataset.retreatDiscountCode);
    let cartCurrency = drawer.dataset.retreatCurrency || baseCurrency;
    let pending = false;
    let renderQueued = false;

    const messages = {
      applied: 'Discount applied:',
      invalid: 'Invalid Discount Code',
      enter: 'Enter a discount code.',
      empty: 'Add a retreat to your cart before applying a code.',
      existing: 'Only one discount code can be applied',
      error: 'Could not apply the discount. Please try again.',
      currency: 'This discount code is available in',
      note: 'Discount applies to the remaining retreat payment, not the deposit.'
    };
    const message = (key) => {
      const text = drawer.querySelector('[data-retreat-discount-messages]')?.dataset[key];
      return text && !/translation missing/i.test(text) ? text : messages[key];
    };
    const positiveInteger = (value) => {
      const number = Number(value);
      return Number.isSafeInteger(number) && number > 0 ? number : 1;
    };
    const money = (cents, currency) => {
      const text = new Intl.NumberFormat(locale, {
        style: 'currency', currency
      }).format(cents / 100);
      return showCurrency ? `${text} ${currency}` : text;
    };
    const setError = (text = '') => {
      const element = drawer.querySelector('[data-retreat-discount-error]');
      if (element) {
        element.className = text ? 'discount-not-applied' : '';
        element.textContent = text;
      }
    };

    const render = () => {
      const discount = discountAmounts.get(activeCode) || 0;
      let totalSavings = 0;
      let summaryItems = 0;

      document.querySelectorAll('[data-retreat-price]').forEach((row) => {
        const regular = row.querySelector('[data-retreat-regular]');
        const original = row.querySelector('[data-retreat-original]');
        const adjusted = row.querySelector('[data-retreat-discounted]');
        if (!regular || !original || !adjusted) return;

        const base = Number(row.dataset.retreatBase);
        const deposit = Number(row.dataset.retreatDeposit);
        const persons = positiveInteger(row.dataset.retreatPersons);
        const quantity = positiveInteger(row.dataset.retreatQuantity);
        const currency = row.dataset.retreatCurrency;
        let savings = 0;
        if (currency === baseCurrency && cartCurrency === baseCurrency &&
            Number.isSafeInteger(base) && base >= 0 &&
            Number.isSafeInteger(deposit) && deposit >= 0) {
          savings = Math.min(discount * persons, Math.max(0, base - deposit));
        }

        const hasDiscount = savings > 0;
        regular.hidden = hasDiscount;
        original.hidden = !hasDiscount;
        adjusted.hidden = !hasDiscount;
        const adjustedText = hasDiscount ? money(base - savings, currency) : '';
        if (adjusted.textContent !== adjustedText) adjusted.textContent = adjustedText;
        const perPerson = row.querySelector('[data-retreat-per-person-amount]');
        if (perPerson && persons > 1 && Number.isSafeInteger(base) && base >= 0) {
          const perPersonText = money(Math.round((base - savings) / persons), currency);
          if (perPerson.textContent !== perPersonText) perPerson.textContent = perPersonText;
        }
        if (drawer.contains(row)) {
          totalSavings += savings * quantity;
          summaryItems++;
        }
      });

      // Keep the code amount visible even before a retreat price is entered.
      drawer.querySelectorAll('[data-retreat-discount-item]').forEach((item) => {
        if (item.dataset.retreatCurrency !== baseCurrency) return;
        totalSavings += discount * positiveInteger(item.dataset.retreatPersons) *
          positiveInteger(item.dataset.retreatQuantity);
        summaryItems++;
      });

      const status = drawer.querySelector('[data-retreat-discount-status]');
      if (!status) return;
      status.replaceChildren();
      if (!discount || !summaryItems) return;
      if (cartCurrency !== baseCurrency) {
        setError(`${message('currency')} ${baseCurrency}.`);
        return;
      }
      const applied = document.createElement('div');
      applied.className = 'discount-applied';
      applied.textContent = `${message('applied')} ${activeCode} — ${money(totalSavings, cartCurrency)}`;
      const note = document.createElement('div');
      note.className = 'note-div';
      note.textContent = message('note');
      status.append(applied, note);
    };

    const requestCart = async (path, options = {}) => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}${path}`, {
        credentials: 'same-origin', cache: 'no-store', ...options
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };

    const apply = async () => {
      if (pending) return;
      const input = drawer.querySelector('#discount-code-input');
      const button = drawer.querySelector('#apply-discount-button');
      if (!input || !button) return;
      const code = normalize(input.value);
      setError();
      if (!code) {
        setError(message('enter'));
        return;
      }
      if (!discountAmounts.has(code)) {
        setError(message('invalid'));
        return;
      }

      pending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const checkout = drawer.querySelector('.checkout__button');
      const checkoutWasDisabled = checkout?.disabled;
      if (checkout) checkout.disabled = true;
      try {
        const cart = await requestCart('cart.js');
        if (!Array.isArray(cart.items) || cart.items.length === 0) {
          setError(message('empty'));
          return;
        }
        if (cart.currency !== baseCurrency) {
          setError(`${message('currency')} ${baseCurrency}.`);
          return;
        }
        if (cart.cart_level_discount_applications?.length > 0) {
          setError(message('existing'));
          return;
        }

        const updated = await requestCart('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { discount_applied: code } })
        });
        if (normalize(updated.attributes?.discount_applied) !== code) {
          throw new Error('Discount was not saved');
        }
        activeCode = code;
        cartCurrency = updated.currency || cart.currency;
        drawer.dataset.retreatDiscountCode = activeCode;
        drawer.dataset.retreatCurrency = cartCurrency;
        input.value = code;
        render();
      } catch {
        setError(message('error'));
      } finally {
        pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (checkout) checkout.disabled = checkoutWasDisabled;
      }
    };

    drawer.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('#apply-discount-button')) {
        event.preventDefault();
        void apply();
      }
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target instanceof Element &&
          event.target.matches('#discount-code-input')) {
        event.preventDefault();
        void apply();
      }
    });

    const observer = new MutationObserver((records) => {
      const itemSelector = '[data-retreat-price], [data-retreat-discount-item]';
      const relevant = records.some((record) =>
        [...record.addedNodes, ...record.removedNodes].some((node) =>
          node instanceof Element &&
          (node.matches(itemSelector) || node.querySelector(itemSelector))
        )
      );
      if (!relevant || renderQueued) return;
      renderQueued = true;
      queueMicrotask(() => {
        renderQueued = false;
        render();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    const input = drawer.querySelector('#discount-code-input');
    if (input && !input.value && discountAmounts.has(activeCode)) input.value = activeCode;
    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
